/*
  GC: Blog kategori sekmeleri — sayfa yenilemeden filtreleme (2026-08-04)
  Sekmeye tıklanınca hedef URL fetch edilip sadece blog listesi, breadcrumb ve
  sekme satırı DOM'da değiştiriliyor. URL history.pushState ile güncelleniyor,
  böylece geri/ileri tuşları ve link paylaşımı çalışmaya devam ediyor.
  JS çalışmazsa linkler normal şekilde çalışır (progressive enhancement).
*/
(function () {
  var TABS = '.gc-blog-kategori';
  var LIST = '[id*="__main-blog"]';

  function listEl() {
    return document.querySelector(LIST);
  }

  function ayniOrigin(url) {
    try {
      return new URL(url, location.href).origin === location.origin;
    } catch (e) {
      return false;
    }
  }

  // Temanın giriş animasyonları (xo-animate) IntersectionObserver ile ilk
  // yüklemede kuruluyor; sonradan DOM'a eklenen kartlar opacity 0.01'de takılı
  // kalıyor. AJAX ile gelen içerikte animasyonu devre dışı bırakıp görünür yapıyoruz.
  function animasyonKapat(kok) {
    kok.querySelectorAll('xo-animate').forEach(function (el) {
      el.removeAttribute('xo-type');
      el.setAttribute('xo-visible', '');
      el.style.animation = 'none';
      el.style.opacity = '1';
    });
  }

  var yukleniyor = false;

  function yukle(url, pushState) {
    var mevcut = listEl();
    if (!mevcut || yukleniyor) return;
    yukleniyor = true;
    mevcut.classList.add('gc-blog-yukleniyor');

    fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var yeniListe = doc.querySelector(LIST);
        if (!yeniListe) throw new Error('liste bulunamadi');

        animasyonKapat(yeniListe);
        listEl().replaceWith(yeniListe);
        // xo-animate custom element'i DOM'a girince kendini yeniden kuruyor,
        // bu yüzden ekledikten sonra bir kez daha sıfırlıyoruz.
        animasyonKapat(yeniListe);
        requestAnimationFrame(function () {
          animasyonKapat(yeniListe);
        });
        setTimeout(function () {
          animasyonKapat(yeniListe);
        }, 60);

        var parcalar = [TABS, '.breadcrumb'];
        parcalar.forEach(function (sel) {
          var eski = document.querySelector(sel);
          var yeni = doc.querySelector(sel);
          if (eski && yeni) eski.replaceWith(yeni);
        });

        if (doc.title) document.title = doc.title;
        if (pushState) history.pushState({ gcBlog: 1 }, '', url);

        var liste = listEl();
        if (liste) {
          liste.classList.remove('gc-blog-yukleniyor');
          var ust = liste.getBoundingClientRect().top;
          if (ust < 0) liste.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      })
      .catch(function () {
        // Bir sorun olursa normal sayfa geçişine düş.
        window.location.href = url;
      })
      .then(function () {
        yukleniyor = false;
      });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest('.gc-blog-kategori__link');
    if (!link || !listEl() || !ayniOrigin(link.href)) return;
    e.preventDefault();
    yukle(link.href, true);
  });

  // İlk giriş de bizim state'imizle işaretlensin ki geri tuşu buraya dönerken
  // içerik bayat kalmasın.
  if (listEl()) history.replaceState({ gcBlog: 1 }, '');

  window.addEventListener('popstate', function (e) {
    if (!listEl()) return;
    if (e.state && e.state.gcBlog) yukle(location.href, false);
  });
})();
